import React, { FC, useCallback, useLayoutEffect, useMemo } from 'react';
import { Icon, Tabs, TabItem, usePrevious, useT } from '@frontegg/react-core';
import { useHistory } from 'react-router-dom';
import { ConnectivityWebhooksForm } from './ConnectivityWebhooksForm';
import { ConnectivityWebhooksLog } from './ConnectivityWebhooksLog';
import { IWebhookLocationState } from './interfaces';
import { useConnectivityState } from '@frontegg/react-hooks';

const itemsArray = ['common.detail', 'common.logs'];

export const ConnectivityWebhooksEdit: FC = () => {
  const { t } = useT();
  const items: TabItem[] = useMemo(() => itemsArray.map((el) => ({ Title: t(el) })), [t]);

  const {
    replace: historyReplace,
    location: { state: locationState, ...location },
  } = useHistory<IWebhookLocationState>();

  const { error, webhook, isSaving } = useConnectivityState();

  const prevIsSaving = usePrevious(isSaving);
  const preparedWebhook = webhook?.data ?? webhook;
  const data = useMemo(() => webhook && preparedWebhook?.find(({ _id }) => _id === locationState.id), [
    webhook?.data,
    locationState,
  ]);

  const onBack = useCallback(() => {
    historyReplace({ ...location, state: { ...locationState, view: 'list', id: undefined } });
  }, [historyReplace, location, locationState]);

  useLayoutEffect(() => {
    !error && prevIsSaving && !isSaving && onBack();
  }, [prevIsSaving, isSaving, onBack, error]);

  const onChangeTab = useCallback(
    (_event: React.MouseEvent<HTMLDivElement>, activeIndex: number) => {
      historyReplace({ ...location, state: { ...locationState, view: activeIndex === 1 ? 'log' : 'edit' } });
    },
    [historyReplace, location, locationState]
  );

  return (
    <div className='fe-connectivity__content'>
      <div className='fe-connectivity__content-heading'>
        <span onClick={onBack} className={'fe-back-button fe-block'}>
          <Icon data-test-id='backBtn' name='back' />
        </span>
        {data?.displayName ?? t('connectivity.addNewHook')}
      </div>
      {data && <Tabs items={items} activeTab={locationState.view === 'edit' ? 0 : 1} onTabChange={onChangeTab} />}
      {locationState.view === 'edit' ? <ConnectivityWebhooksForm data={data ?? null} /> : <ConnectivityWebhooksLog />}
    </div>
  );
};
